

exports.__esModule = true;
/**
 * Returns the appropriate billing agreement xo-content key.
 *
 *   enterpriseAgreement.{CODE}NoFiStickyConsentSignup
 *   billingAgreement.signupAgreementCibStickyPay
 *   billingAgreement.signupAgreementCibStickyContinue
 *   billingAgreement.signupAgreementFiStickyPay
 *   billingAgreement.signupAgreementFiStickyContinue
 *
 * @param {Object} opts
 * @param {opts.cart} a CheckoutCartModel instance
 * @param {opts.appData} a CheckoutAppDataModel instance
 * @return {String}
 */

var getBAContentKey = exports.getBAContentKey = function getBAContentKey(opts) {
    var consentCode = opts.cart.get('billing.consent_code');

    if (consentCode) {
        var signupKey = 'NoFiStickyConsentSignup';
        return 'enterpriseAgreement.' + consentCode + signupKey;
    }

    var keyPrefix = 'billingAgreement.signupAgreement';
    var isCIB = opts.cart.get('billing.type') === 'CHANNEL_INITIATED_BILLING';
    var type = isCIB ? 'Cib' : 'Fi';

    var useraction = opts.appData.useraction();
    var action = useraction === 'commit' ? 'Pay' : 'Continue';

    var keySuffix = type + 'Sticky' + action;
    return '' + keyPrefix + keySuffix;
};

/**
 * Returns the appropriate RP xo-content key.
 *
 *   billingAgreement.signupRpAgreementFiStickyPay
 *   billingAgreement.signupRpAgreementFiStickyContinue
 *
 * @param {Object} opts
 * @param {opts.cart} a CheckoutCartModel instance
 * @param {opts.appData} a CheckoutAppDataModel instance
 * @return {String}
 */
var getRPContentKey = exports.getRPContentKey = function getRPContentKey(opts) {
    var keyPrefix = 'billingAgreement.signupRpAgreementFiSticky';
    var useraction = opts.appData.useraction();
    var action = useraction === 'commit' ? 'Pay' : 'Continue';
    return '' + keyPrefix + action;
};


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/lib/contentKeys.js
// module id = ./components/xo-guest-components/src/lib/contentKeys.js
// module chunks = 1